import AssetSubmissionVideos from "Components/Shared/AssetSubmissionVideos";

const DrillVideoSubmissions = () => {
  return <AssetSubmissionVideos uploadPurpose="drill" />;
};

export default DrillVideoSubmissions;
